import { TableOperations } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';

export const hasSearchApplied = (dataOperations?: TableOperations): boolean => {
	return !!dataOperations?.search;
};
